import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_zoomout",
  "use": "icon-map_zoomout-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_zoomout\">\n<g id=\"icon-map_zoomout_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 15 16 L 16 15 C 13.964844 10.683594 14.789063 3.644531 9.941406 1.359375 C 3.601563 -1.621094 -2 6.589844 2.519531 11.683594 C 5.429688 15 11.207031 14 15 16 M 7 2.660156 C 12.75 2.078125 13.195313 11 7.957031 12 C 1.75 13.160156 0.847656 3.292969 7 2.660156 M 7 4 C 6 6.125 6 6.101563 4 7 L 4 8 C 6 9 6 9 7 11 L 8 11 C 8.898438 9 8.875 9 11 8 L 11 7 C 9.253906 6.175781 8.351563 5.402344 7 4 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_zoomout.svg
// module id = m7iM
// module chunks = 24